import React from 'react';
import { Shuffle } from 'lucide-react';

interface FeatureSettingsSectionProps {
  formState: {
    enableRandomization: boolean;
  };
  sport: string;
  onToggleChange: (field: string, value: boolean) => void;
}

export const FeatureSettingsSection: React.FC<FeatureSettingsSectionProps> = ({
  formState,
  sport,
  onToggleChange
}) => {
  return (
    <div className="space-y-3">
        {/* Position Randomization */}
        <div className="bg-secondary-hover rounded-xl p-3">
          <label className="flex items-start space-x-3 cursor-pointer">
            <input
              type="checkbox"
              className="mt-1 rounded border-gray-300 text-primary focus:ring-primary"
              checked={formState.enableRandomization || false}
              onChange={(e) => onToggleChange('enableRandomization', e.target.checked)}
            />
            <div className="flex-1">
              <div className="flex items-center">
                <Shuffle className="h-4 w-4 mr-2 text-primary" />
                <span className="font-medium text-dark">Enable Position Randomization</span>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                Add a randomization button to depth charts for quickly assigning players to positions. 
                Great for {sport === 'Baseball' || sport === 'Softball' 
                  ? 'rotating fielding positions across innings with fair play rules' 
                  : 'practice lineups and scrimmages'}.
              </p>
            </div>
          </label>
        </div>
      </div>
  );
}; 